(() => {
  const policyAccountLoginUrl = document.body.dataset.xfunAccountLoginUrl;
  if (policyAccountLoginUrl) {
    document.querySelectorAll('.shopify-policy__body a[href="https://account.x-fun.shop"], .shopify-policy__body a[href="https://account.x-fun.shop/"]').forEach(link => {
      link.setAttribute('href', policyAccountLoginUrl);
    });
  }
  const groups = Array.from(document.querySelectorAll('[data-xfl-nav-group]'));
  groups.forEach(group => {
    group.addEventListener('toggle', () => {
      if (group.open) groups.forEach(other => { if (other !== group) other.open = false; });
    });
    group.addEventListener('keydown', event => {
      if (event.key !== 'Escape' || !group.open) return;
      event.preventDefault();
      group.open = false;
      group.querySelector('summary')?.focus();
    });
    group.addEventListener('focusout', () => {
      requestAnimationFrame(() => {
        if (!group.contains(document.activeElement)) group.open = false;
      });
    });
  });
  document.addEventListener('click', event => {
    groups.forEach(group => {
      if (group.open && !group.contains(event.target)) group.open = false;
    });
  });
})();
